import PartnershipInfoLinksPage from './PartnershipInfoLinksPage';

export default PartnershipInfoLinksPage;
